export default {
      id: "nm-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "sprite.svg#nm-usage",
      toString: function () {
        return this.url;
      }
    }